import ElementContent from '@/components/sections/builder/elements/footer/footer-copyright/content';
import ElementSetting from '@/components/sections/builder/elements/footer/footer-copyright/settings';
import { BetweenHorizontalStart } from 'lucide-react';

const defaultData = {
  name: 'Copyright',
  topPadding: 0,
  bottomPadding: 0,
  text: '© 2024 Powered by Jubelio',
  textAlignment: 'left',
};

const ElementPreviewIcon = BetweenHorizontalStart;

const FooterCopyright = {
  type: 'footer_copyright_section',
  group: 'footer',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [],
  childs: [],
};

export default FooterCopyright;
